import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { PortfolioPropertyTag } from '@acp/shared';
import { useUpdatePropertyForm } from '../../hooks/use-update-property-form';
import { EditPropertyForm } from './edit-property-form';
import { useProperty } from '../../hooks/use-property';
import { EditIntegratedPropertyForm } from './edit-integrated-property-form';

export function EditPropertyModal({
    propertyId,
    isOpen,
    onClose,
}: {
    propertyId: number;
    isOpen: boolean;
    onClose: () => void;
}) {
    const {
        updatePropertyDetailsMutation,
        handleClose,
    } = useUpdatePropertyForm({ propertyId, onClose, enforceValidKey: false });

    const propertyQuery = useProperty(propertyId);
    const tags = propertyQuery.data?.tags ?? [];
    const isPropertyIntegrated = tags.includes(PortfolioPropertyTag.Integrated);

    return (
        <Modal
            isOpen={isOpen}
            autoFocus={false}
            closeOnEsc={!updatePropertyDetailsMutation.isPending}
            closeOnOverlayClick={!updatePropertyDetailsMutation.isPending}
            onClose={handleClose}
            size="2xl"
        >
            <ModalOverlay />
            <ModalContent>
                {isPropertyIntegrated ? (
                    <EditIntegratedPropertyForm
                        propertyId={propertyId}
                        onClose={onClose}
                    />
                ) : (
                    <EditPropertyForm
                        propertyId={propertyId}
                        onClose={onClose}
                        enforceValidKey={false}
                    />
                )}
            </ModalContent>
        </Modal>
    );
}
